import { h } from 'preact'
import classNames from 'clsx'

import styles from './index.module.scss'

export const SimpleList = ({ children, className, ...rest }) => (
  <ol className={classNames(
    className,
    styles['a-simple-list'],
  )} {...rest}>
    {children}
  </ol>
)

export const SimpleListEntry = ({ children, className, ...rest }) => (
  <li className={classNames(
    className,
    styles['a-simple-list__entry'],
  )} {...rest}>
    {children}
  </li>
)
